import { AnyAction, ThunkAction, combineReducers } from '@reduxjs/toolkit';
import events, { initialState as eventsInitialState } from './events/events'; // Import the initial state of events
import registrations, { initialState as registrationsInitialState } from './registrations/registrations';
import program, { initialState as programInitialState } from './program/program'; // Import initial state for program
import institution, { initialState as institutionInitialState } from './institution/institution';
import paymentData, { initialState as paymentDataInitialState } from './paymentData';
import misc, { initialState as miscInitialState } from './misc/misc';
import participant, { initialState as participantInitialState } from './participant/participant';
import { resetAll, resetForLoading } from './actions';
import { deleteState } from './localStorage'

// Combine all reducers
const appReducer = combineReducers({
  events,
  registrations,
  program,
  institution,
  misc,
  paymentData,
  participant,
});

// Root reducer with reset functionality
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) => {
  if (action.type === resetForLoading.type) {
    // Reset only the registrations and participant slices by replacing them with their initial states
    state = {
      ...state, // Keep the current state for all slices
      registrations: state?.registrations ||registrationsInitialState, // Reset registrations slice
      participant: state?.participant || participantInitialState,     // Reset participant slice
      events: state?.events || eventsInitialState, // Ensure events slice is not undefined, fallback to eventsInitialState
      program: state?.program || programInitialState, // Ensure program slice is not undefined
      institution: state?.institution || institutionInitialState, // Ensure institution slice is not undefined
      misc: state?.misc || miscInitialState,                  // Ensure misc slice is not undefined
      paymentData: state?.paymentData || paymentDataInitialState,    // Ensure paymentData slice is not undefined
    };
  } else if (action.type === resetAll.type) {
    deleteState()
    state = undefined
  }
  
  // Continue with the normal reducer chain (other actions are handled by appReducer)
  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;

export default rootReducer;